import React from 'react'
import classNames from 'classnames'
import styles from './DatePicker.module.css'
import { default as stylesInput } from '../Input/Input.module.css'
import { default as generalStyle } from '../Theme/GeneralTheme.module.css'

import { default as ReactDatePicker } from 'react-datepicker'
import {
  MdCalendarToday,
  MdFiberManualRecord,
  MdClose,
} from 'react-icons/md'

import eventTypes from '../../utils/enum/eventTypes'
import { isToday, getEventByType } from './utils'

function DatePicker({
  className,
  events,
  visible,
  onClear,
  iconCalendar = <MdCalendarToday />,
  closeOnScroll,
  selectsRange = false,
  showDisabledMonthNavigation,
  timeInputLabel,
  showTimeInput,
  timeCaption,
  calendarContainer,
  onInputClick,
  showMonthYearPicker,
  showFullMonthYearPicker,
  showTwoColumnMonthYearPicker,
  showFourColumnMonthYearPicker,
  isStartEndTime,
  showYearPicker,
  showTimeSelectOnly,
  startDate,
  endDate,
  minDate,
  maxDate,
  minTime,
  maxTime,
  isClearable,
  selected,
  popperClassName,
  calendarClassName,
  timeClassName,
  popperPlacement,
  popperModifiers,
  dateFormat = 'dd/MM/yyyy',
  timeFormat,
  placeholderText = ' ',
  excludeDates,
  excludeDateIntervals,
  monthsShown = 1,
  withPortal = false,
  inline = false,
  showTimeSelect = false,
  locale,
  disabledKeyboardNavigation,
  shouldCloseOnSelect = true,
  filterDate,
  fixedHeight,
  includeDates,
  includeDateIntervals,
  openToDate,
  portalId,
  tabIndex,
  todayButton,
  excludeTimes,
  filterTime,
  includeTimes,
  injectTimes,
  timeIntervals,
  customInput,
  dayClassName,
  onBlur,
  onChange,
  onChangeRaw,
  onCalendarClose,
  onCalendarOpen,
  selectsStart,
  selectsEnd,
  value,
  ...props
}) {
  const renderStatesContents = (day, current) => {
    const alertsCurrent = getEventByType(current, eventTypes.ALERT, events)
    const scheduleCurrent = getEventByType(current, eventTypes.SCHEDULE, events)
    const holidaysCurrent = getEventByType(current, eventTypes.HOLIDAY, events)

    const { className } = props;
    const childrenClassNames = classNames([
      scheduleCurrent?.length > 0 && styles.datepicker_day_scheduled,
      holidaysCurrent?.length > 0 && styles.datepicker_day_holiday,
      alertsCurrent?.length > 0 && styles.datepicker_day_alert,
      isToday(current) && styles.datepicker_day_today,
    ], className)

    return (
      <div
        className={childrenClassNames}
      >
        <span
          title={createTooltip(alertsCurrent, scheduleCurrent, holidaysCurrent)}
        >
          {day}
        </span>

        {holidaysCurrent?.length > 0 && <MdFiberManualRecord />}
      </div>
    )
  }

  const createTooltip = (
    alertsCurrent = [],
    scheduleCurrent = [],
    holidaysCurrent = [],
  ) => {
    let allEventsToday = [
      ...alertsCurrent,
      ...scheduleCurrent,
      ...holidaysCurrent,
    ]
    return allEventsToday.map((event) => event.description).join('\n')
  }

  return (
    <div
      className={classNames([
        generalStyle.general_style,
        showTimeSelectOnly && !isStartEndTime && styles.container_time_only,
        showTimeSelectOnly &&
          isStartEndTime &&
          styles.container_time_only_multiple,
        showTimeSelectOnly && inline && styles.input_inline_time_only,
        styles.date_picker_container,
        props.disabled && styles.data_picker_disabled,
        props.readOnly && styles.data_picker_readonly,
        selectsRange && !inline && !customInput && styles.input_range,
        !inline && customInput && monthsShown > 1 && styles.input_fixed_height,
        inline && monthsShown > 1 && styles.input_inline,
      ])}
      
    >
      <ReactDatePicker
        locale={locale}
        closeOnScroll={closeOnScroll}
        className={classNames([stylesInput.input, className])}
        selected={selected}
        startDate={startDate}
        endDate={endDate}
        showPopperArrow={false}
        onChange={onChange}
        onChangeRaw={onChangeRaw}
        monthsShown={monthsShown}
        selectsRange={selectsRange}
        dateFormat={dateFormat}
        popperClassName={popperClassName}
        popperPlacement={popperPlacement}
        popperModifiers={popperModifiers}
        renderDayContents={renderStatesContents}
        calendarClassName={calendarClassName}
        placeholderText={placeholderText}
        withPortal={withPortal}
        inline={inline}
        showTimeSelect={showTimeSelect}
        excludeDates={excludeDates}
        excludeDateIntervals={excludeDateIntervals}
        disabledKeyboardNavigation={disabledKeyboardNavigation}
        minDate={minDate}
        maxDate={maxDate}
        showDisabledMonthNavigation={showDisabledMonthNavigation}
        shouldCloseOnSelect={shouldCloseOnSelect}
        filterDate={filterDate}
        fixedHeight={fixedHeight}
        includeDates={includeDates}
        includeDateIntervals={includeDateIntervals}
        onBlur={onBlur}
        openToDate={openToDate}
        portalId={portalId}
        tabIndex={tabIndex}
        todayButton={todayButton}
        excludeTimes={excludeTimes}
        filterTime={filterTime}
        includeTimes={includeTimes}
        injectTimes={injectTimes}
        timeFormat={timeFormat}
        timeInputLabel={timeInputLabel}
        showTimeInput={showTimeInput}
        timeIntervals={timeIntervals}
        timeCaption={timeCaption}
        minTime={minTime}
        maxTime={maxTime}
        customInput={customInput}
        calendarContainer={calendarContainer}
        onCalendarClose={onCalendarClose}
        onCalendarOpen={onCalendarOpen}
        dayClassName={dayClassName}
        open={visible}
        onInputClick={onInputClick}
        timeClassName={timeClassName}
        showMonthYearPicker={showMonthYearPicker}
        showFullMonthYearPicker={showFullMonthYearPicker}
        showTwoColumnMonthYearPicker={showTwoColumnMonthYearPicker}
        showFourColumnMonthYearPicker={showFourColumnMonthYearPicker}
        showYearPicker={showYearPicker}
        showTimeSelectOnly={showTimeSelectOnly}
        selectsStart={selectsStart}
        selectsEnd={selectsEnd}
        {...props}
      >
        {props.children}
      </ReactDatePicker>

      {!inline && !customInput && (
        <React.Fragment>
          {!isClearable
            ? iconCalendar
            : IconInputClenable(startDate, selected, onClear, iconCalendar)}
        </React.Fragment>
      )}
    </div>
  )
}

const IconInputClenable = (startDate, selected, onClear, iconCalendar) => {
  return (
    <React.Fragment>
      {startDate == null && selected == null ? (
        iconCalendar
      ) : (
        <span onClick={onClear}>
          <MdClose />
        </span>
      )}
    </React.Fragment>
  )
}

export { DatePicker }
